import React, { useState, useEffect } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

const EditDoctor = ({ doctor, open, onClose, onDoctorUpdated }) => {
  const [editedDoctor, setEditedDoctor] = useState({ Name: '', Specialty: '', Phone: '' });

  useEffect(() => {
    if (doctor) {
      setEditedDoctor(doctor);
    }
  }, [doctor]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedDoctor((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const doctorRef = doc(db, 'hvac', 'GenericData', 'Doctors', doctor.id);
      await updateDoc(doctorRef, editedDoctor);
      onDoctorUpdated(editedDoctor);
      onClose();
    } catch (error) {
      console.error('Error updating doctor:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Doctor</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          name="Name"
          value={editedDoctor.Name}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Specialty"
          name="Specialty"
          value={editedDoctor.Specialty}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Phone"
          name="Phone"
          value={editedDoctor.Phone}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Cancel</Button>
        <Button onClick={handleSave} color="primary">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDoctor; 